import { useModalContext } from '@/shared/contexts/Modal'

import { Button, type Variant } from './Button'
import {
  Modal,
  ModalDescription,
  ModalFooter,
  ModalHeader,
  ModalTitle
} from './Modal'

interface ConfirmationModalProps {
  title: string
  description: string
  onConfirm: () => void
  confirmText?: string
  cancelText?: string
  confirmButtonVariant?: Variant
}

export const ConfirmationModal = ({
  title,
  description,
  onConfirm,
  confirmText = 'Confirmar',
  cancelText = 'Cancelar',
  confirmButtonVariant = 'primary'
}: ConfirmationModalProps) => {
  const { closeModal } = useModalContext()

  const handleConfirm = () => {
    onConfirm()
    closeModal()
  }

  return (
    <Modal>
      <ModalHeader>
        <ModalTitle className="text-center">{title}</ModalTitle>
      </ModalHeader>
      <ModalDescription className="my-4 text-center">
        {description}
      </ModalDescription>
      <ModalFooter className="flex gap-4">
        <Button variant="secondary" onClick={closeModal} className="w-full">
          {cancelText}
        </Button>
        <Button
          variant={confirmButtonVariant}
          onClick={handleConfirm}
          className="w-full"
        >
          {confirmText}
        </Button>
      </ModalFooter>
    </Modal>
  )
}
